<template>
  <div class="role">
    <div class="card-container">
      <div class="card-title">
        考勤数据筛选
      </div>
      <div class="card-content">
        <a-form :form="form" @submit="handleSubmit">
          <a-row>
            <a-col class="search-item" :span="5">
              <a-form-item
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                label="用户名"
              >
                <a-input v-decorator="['userName']" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="5">
              <a-form-item
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                label="选择日期"
              >
                <a-month-picker
                  v-model="defaultValMonthOpera"
                  @change="onChangeMonthOpera"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="5">
              <a-form-item
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                label="考勤状态"
              >
                <a-select
                  v-decorator="[
                    'roleType',
                    {
                      initialValue: ''
                    }
                  ]"
                >
                  <a-select-option value="">
                    全部
                  </a-select-option>
                  <a-select-option value="0">
                    正常
                  </a-select-option>
                  <a-select-option value="1">
                    异常
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="4" align="right">
              <a-form-item>
                <a-button type="primary" class="mr8" html-type="submit">
                  查询
                </a-button>
                <a-button @click="resetForm">
                  重置
                </a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="card-container mrt16">
      <a-row>
        <a-col :span="12">
          <div class="card-title">
            监管列表
          </div>
        </a-col>
      </a-row>
      <div class="card-content">
        <a-table
          class="table-content"
          :columns="columns"
          :data-source="formData"
          :loading="loading"
          :pagination="pagination"
          :row-key="record => record.id"
          @change="handleTableChange"
        >
          <template slot="abnormal" slot-scope="record">
            <div v-show="record === 0">
              <IconFont
                type="iconzhengchang-01" theme="twoTone" two-tone-color="#52c41a"
                style="margin-right:5px"
              />正常
            </div>
            <div v-show="record === 1">
              <IconFont
                type="iconyichang-01" theme="twoTone" two-tone-color="orange"
                style="margin-right:5px"
              />异常
            </div>
          </template>
          <template slot="operate" slot-scope="record">
            <a-button
              class="table-btn-link"
              type="link"
              size="small"
              @click="linkDetail(record)"
            >
              查看考勤月历
            </a-button>
          </template>
        </a-table>
      </div>
      <a-modal
        v-model="showcalendar" width="1200px" :footer="null"
        title="考勤月历"
      >
        <a-calendar @select="selectDay" @panelChange="onPanelChange">
          <ul slot="dateCellRender" slot-scope="value" class="events">
            <a-badge v-if="getIsFlag(value) !== 0" :color="getIsFlag(value) === -1 ? 'orange' : 'blue'" />
            <!-- <div v-for="(item,index) in getListData(value)" :key="index">
              <a-badge v-if="item.isShow !== undefined && item.isShow " :color="item.isflag === -1 ? 'orange' : 'blue'" />
            </div> -->
            <span v-if="getIsShow(value) === true">
              <div v-for="(item,index) in getListData(value)" :key="index">

                <div>
                  <span v-if="item.singType && item.singType === 1" style="color:gray;">上午:</span>
                  <span v-if="item.singType && item.singType === 1 && item.signIn === 1">正常,</span>
                  <span v-if="item.singType && item.singType === 1 && item.signIn === 0">异常,</span>
                  <!-- <span v-if="item.singType && item.singType === 1" style="color:gray;">下班:</span> -->
                  <span v-if="item.singType && item.singType === 1 && item.signOut === 1">正常</span>
                  <span v-if="item.singType && item.singType === 1 && item.signOut === 0">异常</span>
                </div>
                <div>

                </div>
                <div>
                  <span v-if="item.singType && item.singType === 2" style="color:gray;">下午:</span>
                  <span v-if="item.singType && item.singType === 2 && item.signIn === 1">正常,</span>
                  <span v-if="item.singType && item.singType === 2 && item.signIn === 0">异常,</span>
                  <!-- <span v-if="item.singType && item.singType === 2" style="color:gray;">下班:</span> -->
                  <span v-if="item.singType && item.singType === 2 && item.signOut === 1">正常</span>
                  <span v-if="item.singType && item.singType === 2 && item.signOut === 0">异常</span>
                  <div>

                  </div>
                </div>
              </div>
            </span>
          </ul>
        </a-calendar>
      </a-modal>
    </div>
  </div>
</template>
<script>
import {
  iconFontComponent
} from '@/components/mixins/mixins.js'
import { getSignList, getSalaryDetail } from '@/api/checkwork'
import moment from 'moment'
const columns = [
  {
    title: '用户名',
    dataIndex: 'userName'
  },
  {
    title: '设备名称',
    dataIndex: 'name'
  },
  {
    title: '时间区间',
    dataIndex: 'selectDate'
  },
  // {
  //   title: '平均工时（h）',
  //   dataIndex: 'hours'
  // },
  {
    title: '出勤天数（天）',
    dataIndex: 'isOn'
  },
  {
    title: '缺勤天数（天）',
    dataIndex: 'isOff'
  },
  {
    title: '考勤状态',
    dataIndex: 'abnormal',
    scopedSlots: { customRender: 'abnormal' }
  },
  {
    title: '操作',
    align: 'center',
    width: '140px',
    scopedSlots: { customRender: 'operate' }
  }
]
const getFullYear = new Date().getFullYear()
var month = new Date().getMonth() + 1
if (month.toString().length === 1) {
  month = '0' + month
}
moment.suppressDeprecationWarnings = true
export default {
  mixins: [iconFontComponent],
  data () {
    return {
      defaultValMonthOpera: getFullYear + '-' + month,
      showcalendar: false,
      loading: false,
      columns,
      formData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        total: 0
      },
      datalist: [],
      monthNum: moment().format('YYYY-MM')
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, {})
  },
  mounted () {
    this.getSignList()
  },
  methods: {
    moment,
    selectDay (value) {
      const day = moment(value._d).format('YYYY-MM-DD')
      const itemIndex = this.datalist.findIndex(s => s.day === day)
      if (itemIndex > -1) {
        this.datalist[itemIndex].isShow = true
      }
    },
    onPanelChange (value, mode) {
      let monthNum = ''
      monthNum = moment(value._d).format('YYYY-MM')
      this.monthNum = monthNum
      this.getSalaryDetail()
    },
    getListData (value) {
      let memo
      for (let i = 0; i < this.datalist.length; i++) {
        if (value.format('YYYY-MM-DD') === this.datalist[i].day) {
          memo = this.datalist[i].content
        }
      }
      return memo || []
    },
    getIsFlag (value) {
      let num
      for (let i = 0; i < this.datalist.length; i++) {
        if (value.format('YYYY-MM-DD') === this.datalist[i].day) {
          num = this.datalist[i].isflag
        }
      }
      return num || 0
    },
    getIsShow (value) {
      let isShow
      for (let i = 0; i < this.datalist.length; i++) {
        console.log(this.datalist, 'isShow')
        if (value.format('YYYY-MM-DD') === this.datalist[i].day) {
          isShow = this.datalist[i].isShow
        }
      }
      return isShow || false
    },
    onChangeMonthOpera (date, dateString) {
      this.defaultValMonthOpera = dateString
    },
    getSignList () {
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        startTime: this.defaultValMonthOpera,
        userName: this.form.getFieldValue('userName') || ''
      }
      if (this.form.getFieldValue('roleType') !== '') {
        params.type = Number(this.form.getFieldValue('roleType'))
      }
      this.loading = true
      getSignList(params).then(res => {
        this.loading = false
        const result = res.result.list
        result.forEach(element => {
          element.selectDate = this.defaultValMonthOpera
        })
        this.formData = result
        this.pagination.total = res.result.totalCount
      })
    },
    resetForm () {
      // this.defaultValMonthOpera = ''
      this.form.resetFields()
      this.defaultValMonthOpera = getFullYear + '-' + month
      this.getSignList()
    },
    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
      this.getSignList()
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.pagination.current = 1
          this.getSignList()
        }
      })
    },
    linkDetail (item) {
      this.showcalendar = true
      this.productId = item.id
      this.mobile = item.mobile
      this.getSalaryDetail()
    },
    getSalaryDetail () {
      const params = {
        productId: this.productId,
        startTime: this.monthNum,
        mobile: this.mobile
      }
      getSalaryDetail(params).then(res => {
        if (res.code === 0) {
          this.datalist = res.result.list
        }
      })
    }
  }
}
</script>
<style scoped>
/deep/ .ant-badge-status-dot {
    top: -7px;
    left: 125px;
}
/deep/ .events {
  padding-left:0px;
}
</style>
<style lang="stylus">
.role-modal .ant-modal-footer
  text-align center
.del-modal .ant-btn-primary
  display none

</style>
<style lang="stylus" scoped>
.eject_content
  .pic
    .pic_top
      display flex
      margin-bottom: 15px;
      margin-top: 20px;
      span:nth-child(1)
        width: 5px;
        height: 16px;
        background: #1890ff;
        margin-right: 10px;
    .pic_bot
      display: flex;
      margin-bottom: 20px;
      .img_list
        margin 0 10px
        img
          width 130px
          height 100px
          border-radius 4%
</style>
